import { useState } from "react";
import { ListActionsLayout } from "./list-actions-layout.js";
const getEmptyItem = ()=>({
        id: crypto.randomUUID(),
        value: void 0
    });
function useListManager({ maxItems = 5, onChange, defaultValues = [] }) {
    const [items, setItems] = useState(()=>{
        if (0 === defaultValues.length) return [
            getEmptyItem()
        ];
        return defaultValues.map((value)=>({
                id: crypto.randomUUID(),
                value
            }));
    });
    function handleItemChange(value, index) {
        setItems((prevItems)=>{
            const newItems = [
                ...prevItems
            ];
            newItems[index] = {
                ...newItems[index],
                value
            };
            const validValues = newItems.map((item)=>item.value).filter(Boolean);
            onChange?.(validValues);
            return newItems;
        });
    }
    function handleAddItem() {
        if (items.length >= maxItems) return;
        setItems((prev)=>[
                ...prev,
                {
                    id: crypto.randomUUID(),
                    value: void 0
                }
            ]);
    }
    function handleDeleteItem(index) {
        setItems((prevItems)=>{
            const newItems = prevItems.filter((_, idx)=>idx !== index);
            if (0 === newItems.length) return [
                getEmptyItem()
            ];
            const validValues = newItems.map((item)=>item.value).filter(Boolean);
            onChange?.(validValues);
            return newItems;
        });
    }
    function handleDeleteAll() {
        setItems([
            getEmptyItem()
        ]);
        onChange?.([]);
    }
    return [
        ListActionsLayout,
        {
            items,
            canAdd: items.length < maxItems,
            canDeleteAll: !(1 === items.length && !items[0].value),
            onItemChange: handleItemChange,
            onAddItem: handleAddItem,
            onDeleteItem: handleDeleteItem,
            onDeleteAll: handleDeleteAll
        }
    ];
}
export { useListManager };
